import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import AgriProduct from '@/models/AgriProduct.js'

export const useAgriProductStore = defineStore('agriProductStore', () => {
  let syncableModel = useSyncableModel(useApiResource('agri_products'), {
    className: AgriProduct.modelName.name,
    paramKey: AgriProduct.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }
}, {
  persist: true
})
